import { Route, Routes } from "react-router-dom";
import { Error404 } from 'pages';
import EquipmentViewMonitoring from "pages/monitoring/equipment-view";
import EquipmentMonitoring from "pages/monitoring/equipment";

export default function MonitoringEquipmentRoutes(props) {

    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={ <EquipmentMonitoring /> }/>
                
                <Route path=":id" element={ <EquipmentViewMonitoring /> }/>
               
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}